"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMateria = exports.yupMateria = void 0;
const yup = __importStar(require("yup"));
const materia_1 = require("../enums/materia");
exports.yupMateria = yup.object({
    grupo: yup
        .mixed()
        .oneOf(Object.values(materia_1.EMateriaGrupo))
        .default(materia_1.EMateriaGrupo['Base Nacional Comum'])
        .label('Grupo da Matéria'),
    area: yup.mixed().oneOf(Object.values(materia_1.EMateriaArea)).notRequired().label('Área da Matéria'),
    nome: yup.string().default('').max(200, 'Máximo de 200 caracteres').required().label('Nome'),
    nomeAbreviado: yup.string().default('').max(5, 'Máximo de 5 caracteres').required().label('Nome Abreviado'),
    nomeDocumento: yup.string().default('').max(200, 'Máximo de 200 caracteres').label('Nome Documentos'),
    sequencia0: yup.string().default('').max(3, 'Máximo de 3 caracteres').label('Posição na Matriz - Infantil'),
    sequencia1: yup.string().default('').max(3, 'Máximo de 3 caracteres').label('Posição na Matriz - Fundamental'),
    sequencia2: yup.string().default('').max(3, 'Máximo de 3 caracteres').label('Posição na Matriz - Ensino Médio'),
    grau0: yup.boolean().required().default(false).label('Utilizar na Matriz - Infantil'),
    grau1: yup.boolean().required().default(false).label('Utilizar na Matriz - Fundamental'),
    grau2: yup.boolean().required().default(false).label('Utilizar na Matriz - Ensino Médio'),
    isOcultarRelatorio14: yup
        .boolean()
        .required()
        .default(false)
        .label('Ocultar a Matéria no Relatório Final de 1ª a 4ª'),
    reprova: yup.boolean().required().default(false).label('Não Considerar a Matéria para Aprovação'),
    isOcultarBoletim: yup.boolean().required().default(false).label('Ocultar a Matéria no Boletim'),
    isExportarCenso: yup.boolean().required().default(false).label('Não Exportar a Matéria para o Censo'),
    codigoCenso: yup.number().integer().default(0).label('Código Censo'),
    agrupada: yup.boolean().required().default(false).label('Matéria Agrupada'),
    calcma: yup.mixed().oneOf([0, 1, 2]).default(0).label('Cálculo da Matéria Agrupda'),
    subMateria: yup.boolean().required().default(false).label('SubMatéria'),
    idMateriaAgrupada: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('SubMatéria da Matéria'),
    pesoSub: yup.number().required().positive().default(1).label('Peso da SubMatéria'),
    soma: yup.boolean().required().default(false).label('Somar a SubMatéria'),
});
exports.schemaMateria = exports.yupMateria.shape({});
